<template>
    <b-modal ref="modal_edit" hide-footer :title="$t('comment.update')" size="lg" ok-only>
        <b-media>
            <b-img slot="aside" :src="cmt.user ? cmt.user.avatar500x500 : ''" width="64" height="64" alt="placeholder" />
            <textarea class="col-md-12 form-control" rows="3" v-model="cmt.content" @paste="handlePaste"></textarea>
            <error :error="errors.content"></error>
            <div class="row col-md-12">
                <div class="mt-3 mr-3" style="text-align: center" v-for="(img, index) in preview" :key="index">
                    <b-img :src="img" height="64" width="64" alt="placeholder" style="border: #ddd 1px solid" />
                    <h6 class="text-center link" @click="remove(index)"><i class="fa fa-trash"></i>
                        {{ $t('comment.remove') }}</h6>
                    <div v-if="index >= images_length">
                        <error :error="errors['images.' + (index - images_length)]"></error>
                    </div>
                </div>
            </div>
            <span class="link" @click="openUploadImage"><i class="fa fa-picture-o"></i>
                {{ $t('comment.add_image') }}</span>
            <input type="file" class="form-control hidden" ref="files" :multiple="true"
                accept="image/*" @change="change">
            <div class="pull-right mt-2">
                <button class="btn btn-sm btn-primary" @click="update()" :disabled="btn_submit"><i
                        class="fa fa-paper-plane"></i> {{ $t('comment.submit') }}</button>
            </div>
        </b-media>
    </b-modal>
</template>
<script>
export default {
  name: 'edit-child-comment',
  components: {},
  props: [],
  data () {
    return {
      comment: {},
      files: [],
      preview: [],
      images_length: 0,
      index_img: [],
      errors: {},
      cmt: {
        content: ''
      },
      open_upload_image: false,
      checklist_item: {},
      image_index: [],
      btn_submit: false
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    handlePaste (event) {
      const items = (event.clipboardData || event.originalEvent.clipboardData).items
      for (let item of items) {
        if (item.kind === 'file' && item.type.startsWith('image/')) {
          const file = item.getAsFile()
          this.files.push(file)
          const reader = new FileReader()
          reader.onload = (e) => {
            this.preview.push(e.target.result)
          }
          reader.readAsDataURL(file)
        }
      }
    },
    showModal (checklistitem = {}, comment) {
      this.$store.dispatch('Comment/showCommentOfChecklistItem', {
        checklist: { id: this.$route.params.checklist_id }, checklist_item: checklistitem, comment
      }).then(res => {
        this.cmt = res
        this.preview = res.images_resize ? res.images_resize : []
        this.checklist_item = checklistitem
        this.images_length = this.cmt.images.length
        for (var i = 0; i < this.cmt.images.length; i++) {
          this.index_img.push(i)
        }
        this.files = []
        this.image_index = []
        this.$refs.modal_edit.show()
      }).catch(errors => {
        console.log(errors)
      })
    },
    update () {
      const data = new FormData()
      data.append('id', this.cmt.id)
      data.append('content', this.cmt.content)
      data.append('parent_id', this.cmt.parent_id)
      data.append('_method', 'put')
      for (var i = 0; i < this.files.length; i++) {
        let file = this.files[i]
        data.append('images[' + i + ']', file)
      }
      for (var j = 0; j < this.image_index.length; j++) {
        let index = this.image_index[j]
        data.append('image_index[' + j + ']', index)
      }
      console.log(data)

      this.btn_submit = true
      this.$store.dispatch('Comment/updateCommentOfChecklistItem', { checklist: { id: this.$route.params.checklist_id }, checklist_item: this.checklist_item, comment: data }).then(res => {
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.update_success')
        })
        this.$refs.modal_edit.hide()
        this.cmt = {}
        this.files = []
        this.preview = []
        this.image_index = []
        this.errors = {}

        this.$emit('updateSuccess', res)
        this.btn_submit = false
      }).catch(errors => {
        if (errors.status === 422) {
          this.errors = errors.data.error
        }

        this.btn_submit = false
      })
    },
    openUploadImage () {
      this.$refs.files.click()
    },
    change (event) {
      this.open_upload_image = false
      for (var i = 0; i < this.$refs.files.files.length; i++) {
        this.files.push(this.$refs.files.files[i])
        let reader = new FileReader()
        reader.onload = (event) => {
          this.preview.push(event.target.result)
        }
        reader.readAsDataURL(this.$refs.files.files[i])
      }
    },
    remove (index) {
      if (index >= this.images_length) {
        this.files.splice(index - this.images_length, 1)
      }
      if (index < this.images_length) {
        this.images_length = this.images_length - 1
        this.image_index.push(this.index_img[index])
        this.index_img.splice(index, 1)
      }
      this.preview.splice(index, 1)
      delete this.errors['images.' + index]
    }
  }
}
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/views/checklist/view/checklist-item/comment/child-comment/edit-child-comment/index.vue